import { useClerk } from "@clerk/clerk-react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getArtistPath } from "@/components/_helpers";
import { isClerkConfigured, isConvexConfigured } from "@/lib/convex";

interface SignInButtonProps {
  onBeforeOpen?: () => void;
  sx?: object;
  children: React.ReactNode;
}

const BRANCHES_PATH = getArtistPath("Truevined", "/branches");

// Clerk's sign in, opened over the page so a player lands back in the game.
// When Clerk has not loaded (or this build has no Clerk), it falls back to
// The Branches page, which carries the full sign in.
function ClerkSignInButton({ onBeforeOpen, sx, children }: SignInButtonProps) {
  const clerk = useClerk();
  const navigate = useNavigate();
  const open = () => {
    onBeforeOpen?.();
    const back = window.location.href;
    if (clerk.loaded) clerk.openSignIn({ forceRedirectUrl: back, signUpForceRedirectUrl: back });
    else navigate(BRANCHES_PATH);
  };
  return (
    <Box component="button" type="button" onClick={open} sx={sx}>
      {children}
    </Box>
  );
}

function BranchesLinkButton({ onBeforeOpen, sx, children }: SignInButtonProps) {
  const navigate = useNavigate();
  return (
    <Box
      component="button"
      type="button"
      onClick={() => {
        onBeforeOpen?.();
        navigate(BRANCHES_PATH);
      }}
      sx={sx}
    >
      {children}
    </Box>
  );
}

// ClerkProvider is only mounted when both Convex and Clerk are configured
// (see main.tsx), so useClerk is only called under that condition.
export function BranchesSignInButton(props: SignInButtonProps) {
  return isConvexConfigured && isClerkConfigured ? <ClerkSignInButton {...props} /> : <BranchesLinkButton {...props} />;
}

export default BranchesSignInButton;
